/**
 * Check if a giveaway session is currently active (now is between its
 * start and end time on the promotion date).
 *
 * @param {{ promotionDate?: any, startTime?: any, endTime?: any }} session
 * @returns {boolean}
 */
export const checkIsSessionActive = (session) => {
  if (!session?.promotionDate || !session?.startTime || !session?.endTime) return false;
  const now = new Date();
  const date = new Date(session.promotionDate);
  const start = new Date(session.startTime);
  const end = new Date(session.endTime);
  const startDatetime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), start.getHours(), start.getMinutes(), 0);
  const endDatetime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), end.getHours(), end.getMinutes(), 59);
  return now >= startDatetime && now <= endDatetime;
};

/**
 * Check if a giveaway has at least one currently-active session.
 *
 * @param {Array} sessions
 * @returns {boolean}
 */
export const hasActiveSession = (sessions = []) => sessions.some(checkIsSessionActive);
